import React from 'react';
import './style.less';

interface ItemCard {
  children: React.ReactNode,
  style?: React.CSSProperties,
}

const clsPrefix = "c-item-card";
const ItemCard:React.FC<ItemCard> = (props) => {
  return (
    <div className={clsPrefix} style={props.style}>
        {props.children}
    </div>
  )
}

export default ItemCard